import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="form-data"
export default class extends Controller {
  /**
   * Removes all form data entries with empty string values.
   */
  removeEmpty(event) {
    const formData = event.formData;

    [...formData.keys()].forEach((key) => {
      const values = formData.getAll(key);
      formData.delete(key);
      values.filter((v) => v !== '').forEach((v) => formData.append(key, v));
    });
  }
}
